import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom'

import { isApiError } from '@/shared/api/errors'
import { ErrorState } from '@/shared/components/data'
import { log } from '@/shared/lib/log'
import { useT } from '@/shared/i18n'

/**
 * `errorElement` de las rutas.
 *
 * Un 403 del API cae aca y NO se renderiza nada parcial del recurso: mejor una
 * pantalla honesta que media ficha cargada con huecos.
 */
export function RouteErrorBoundary() {
  const error = useRouteError()
  const navigate = useNavigate()

  // Se loguea ANTES de decidir qué pantalla mostrar: lo que interesa es que el
  // hecho quede registrado con su `request_id`, no cuál de los tres textos le
  // tocó al usuario.
  log.error('route_error', {
    status: isRouteErrorResponse(error) ? error.status : isApiError(error) ? error.status : null,
    code: isApiError(error) ? error.code : null,
    request_id: isApiError(error) ? error.requestId : null,
    message: error instanceof Error ? error.message : String(error),
    path: typeof window === 'undefined' ? null : window.location.pathname,
  })

  if (isRouteErrorResponse(error)) {
    return (
      <div className="p-6">
        <ErrorState
          title={error.status === 404 ? 'No encontramos esta página' : `Error ${error.status}`}
          error={new Error(error.statusText || 'La ruta no existe.')}
          onRetry={() => navigate(0)}
        />
      </div>
    )
  }

  const title = isApiError(error)
    ? error.isForbidden
      ? 'No tenés permiso para ver esto'
      : error.isNotFound
        ? 'No encontramos esta página'
        : 'Algo salió mal'
    : 'Algo salió mal'

  return (
    <div className="p-6">
      <ErrorState title={title} error={error} onRetry={() => navigate(0)} />
    </div>
  )
}

export function ForbiddenPage() {
  const t = useT()
  const navigate = useNavigate()

  return (
    <div className="flex min-h-[60vh] items-center justify-center p-6">
      <ErrorState
        title={t('common.error.forbiddenTitle')}
        error={new Error(t('common.error.forbiddenDescription'))}
        onRetry={() => navigate('/portfolio')}
      />
    </div>
  )
}

export function NotFoundPage() {
  const t = useT()
  const navigate = useNavigate()

  return (
    <div className="flex min-h-[60vh] items-center justify-center p-6">
      <ErrorState
        title={t('common.error.notFoundTitle')}
        error={new Error(t('common.error.notFoundDescription'))}
        onRetry={() => navigate('/')}
      />
    </div>
  )
}
